module.exports = __webpack_public_path__ + "static/payment-security-fe98fdc219ac4b3794db1a309c9744a7.jpg";